import React from "react";

// Non-final scores are Provisional; unfinished ones also only count answered questions.
export const PartialTag = ({ answered, total, final, score, testid }) => {
  const partial = answered != null && !!total && answered < total;
  const provisional = final === false && score != null;
  if (!partial && !provisional) return null;
  const count = partial ? `${answered} of ${total} answered` : "";
  const label = provisional ? `Provisional${count ? ` · ${count}` : ""}` : `Partial — ${count}`;
  return (
    <span data-testid={testid} title="Score is not final yet — it counts answered questions only and becomes Final after approval"
      className="inline-block whitespace-nowrap rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800">
      {label}
    </span>
  );
};
